import {
  countTargetRatioDeliverables,
  type TargetRatio,
} from "@nexus/contracts"
import type { TFunction } from "i18next"
import type { ReactNode } from "react"

import type { DetailMetaItem } from "./DetailMetaGrid"

/** Ratio chips and the deliverables row. Empty when the order stored no ratios. */
export function buildOrderTargetRatioMetaItems(
  ratios: readonly TargetRatio[] | null | undefined,
  scriptCount: number,
  t: TFunction,
): DetailMetaItem[] {
  if (!ratios || ratios.length === 0) return []
  const videos = countTargetRatioDeliverables(scriptCount, ratios)
  const scriptsLabel = t("marketplace.sendHandoff.summaryScripts", {
    count: scriptCount,
    defaultValue: "{{count}} scripts",
  })
  const ratiosLabel = t("marketplace.sendHandoff.summaryRatios", {
    count: ratios.length,
    defaultValue: "{{count}} ratios",
  })

  return [
    {
      label: t("marketplace.orders.list.panel.targetRatiosLabel", "Target ratios"),
      value: <TargetRatioChips ratios={ratios} />,
    },
    {
      label: t("marketplace.orders.list.panel.deliverablesLabel", "Deliverables"),
      value: (
        <span className="flex flex-col gap-0.5">
          <span>
            {t("marketplace.orders.list.panel.deliverablesVideos", {
              count: videos,
              defaultValue: "{{count}} videos",
            })}
          </span>
          <span className="text-caption text-muted-foreground">
            {t("marketplace.orders.list.panel.deliverablesFormula", {
              scripts: scriptsLabel,
              ratios: ratiosLabel,
              defaultValue: "{{scripts}} × {{ratios}}",
            })}
          </span>
        </span>
      ),
    },
  ]
}

function TargetRatioChips({ ratios }: { ratios: readonly TargetRatio[] }): ReactNode {
  return (
    <span className="flex flex-wrap gap-1">
      {ratios.map((ratio) => (
        <span
          key={ratio}
          className="rounded-md border border-border bg-muted px-1.5 py-0.5 text-caption text-foreground"
        >
          {ratio}
        </span>
      ))}
    </span>
  )
}
